module.exports = __webpack_public_path__ + "img/tree_folder.05e3a42a.png";